import { create } from 'zustand';

interface WithdrawModalStore {
	isOpen: boolean;
	openWithdrawModal: () => void;
	closeWithdrawModal: () => void;
}

export const useWithdrawModalStore = create<WithdrawModalStore>((set) => ({
	isOpen: false,
	openWithdrawModal: () => set({ isOpen: true }),
	closeWithdrawModal: () => set({ isOpen: false }),
}));
